import { Component, DestroyRef, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, EMPTY, finalize } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { DriversSalaryV2ApiService } from './_api/drivers-salary-v2.api.service';

@Component({
	selector: 'app-drivers-salary-v2-gratyfikant',
	standalone: true,
	imports: [CommonModule, MatButtonModule, MatProgressSpinnerModule, MatTableModule],
	templateUrl: './drivers-salary-v2-gratyfikant.component.html',
})
export class DriversSalaryV2GratyfikantComponent {
	readonly driverId = input.required<string>();

	private readonly destroyRef = inject(DestroyRef);
	private readonly apiService = inject(DriversSalaryV2ApiService);

	readonly salaries = signal<Record<string, unknown>[]>([]);
	readonly columns = signal<string[]>([]);
	readonly isLoading = signal(false);
	readonly loaded = signal(false);
	readonly error = signal<string | null>(null);

	load(): void {
		this.isLoading.set(true);
		this.error.set(null);
		this.apiService
			.getGratyfikantSalariesRaw(this.driverId())
			.pipe(
				catchError((err) => {
					const errorMessage =
						err?.error?.message || err?.message || 'Nie udało się pobrać danych z Gratyfikant.';
					this.error.set(errorMessage);
					return EMPTY;
				}),
				finalize(() => this.isLoading.set(false)),
				takeUntilDestroyed(this.destroyRef),
			)
			.subscribe((response) => {
				const rows = response.data;
				this.salaries.set(rows);
				this.columns.set(rows.length > 0 ? Object.keys(rows[0]) : []);
				this.loaded.set(true);
			});
	}
}
